import App from './App.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createOidcClient, setup } from '@/setup'
import './styles/index.scss'

const app = createApp(App)
export const pinia = createPinia()
export const aschehougOidcClient = createOidcClient()
setup(app)
